module.exports = __webpack_public_path__ + "static/media/thumb4@3x.8e6ee1eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/how-can-be-used/assets/thumb4@3x.png
// module id = 99
// module chunks = 0